import { useQuery } from "@tanstack/react-query";

import { getAllCarbonPrograms } from "services";

import { GET_ALL_CARBON_PROGRAMS } from "consts";

import { CarbonProgram } from "models";

export const useGetAllCarbonPrograms = () =>
  useQuery<CarbonProgram[]>({
    queryKey: [GET_ALL_CARBON_PROGRAMS],
    queryFn: () => getAllCarbonPrograms(),
    refetchOnMount: "always",
  });
